// extracted by mini-css-extract-plugin
export default {"popover-tooltip":"popover-tooltip-pCKjM","dl-related-pdfs":"dl-related-pdfs-XtASh"};